/* 必填项信息 */
import yioksRules from '@/utils/formRules/rules'

/*
* 表单必填选项：
* @formName 校验项label名称（例如：'手机号'）
* @timeFlag 校验时机控制 默认blur；
* */
export function requiredItem (formName, timeFlag) {
  timeFlag || (timeFlag = false)
  formName || (formName = '该项')
  return {
    required: true,
    message: `${formName}是必填信息`,
    trigger: timeFlag ? 'change' : 'blur'
  }
}

/*
* 表单数字选项：
* */
export function numberRequired (formName, timeFlag) {
  timeFlag || (timeFlag = false)
  formName || (formName = '该项')
  return {
    type: 'number',
    message: `${formName}必须为数字`,
    trigger: timeFlag ? 'change' : 'blur'
  }
}

/*
* 手机号校验：
* */
export function phoneRequired (formName) {
  formName || (formName = '该项')

  return {
    required: true,
    validator: (rule, value, callback) => {
      if (!value) {
        callback(new Error(`${formName}是必填项`))
      } else {
        if (yioksRules.phone(value)) {
          callback()
        } else {
          callback(new Error('请输入正确手机号'))
        }
      }
    },
    trigger: 'blur'
  }
}

/* 测试方法： 为动态form表单集中生成验证规则 */
function outRules (formData, listName) {
  let rulesList = {}
  let list = formData[listName]
  if (list.length) {
    list.forEach((item, index) => {
      const keysList = Object.keys(item)
      let aimObj = {}
      keysList.forEach(key => {
        const temObj = {
          [`${[listName]}.${index}.${key}`]: [requiredItem()],
        }
        aimObj = Object.assign({}, aimObj, temObj)

      })

    })
  }
}


export const  idCard_number = function(idCard) {
  if (!idCard) {
    return false;
  }
  idCard = idCard.trim();
  //18位身份证号码的正则表达式
  const regIdCard = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$/;
  //如果通过该验证，说明身份证格式正确，但准确性还需计算
  if (regIdCard.test(idCard)) {
    const idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
    const idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
    let idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
    for (let i = 0; i < 17; i++) {
      idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
    }

    const idCardMod = idCardWiSum % 11;//计算出校验码所在数组的位置
    const idCardLast = idCard.substring(17);//得到最后一位身份证号码

    //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
    if (idCardMod == 2) {
      if (idCardLast == "X" || idCardLast == "x") {
        return true;
      }
    } else {
      //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
      if (idCardLast == idCardY[idCardMod]) {
        return true;
      }
    }
  }
  return false;
}

const idNumberValidator = (ruels, value, callback) => {
  if (value) {
    if (idCard_number(value)) {
      callback();
    } else {
      callback(new Error("请输入正确的身份证号码"));
    }
  }
}

const idNumberValidator45 = (ruels, value, callback) => {
  if (value) {
    if (idCard_number(value)) {
      //获取年龄
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      var age = myDate.getFullYear() - value.substring(6, 10) - 1;
      if (value.substring(10, 12) < month || value.substring(10, 12) == month && value.substring(12, 14) <= day) {
        age++;
      }
      if (age >= '45') {
        callback("教练员年龄在45周岁以下才能报名");
      }
      callback();
    } else {
      callback("请输入正确的身份证号码");
    }
  }
}


/* 校验身份证号 */
export const isIdNumber = () => {
  return {
    validator: idNumberValidator,
    trigger: 'blur'
  }
}

/* 校验身份证号45岁 */
export const isIdNumber45 = () => {
  return {
    validator: idNumberValidator45,
    trigger: 'blur'
  }
}
